import type { UserRole } from '@psp-aggregator/sdk';

export enum UserRoleEnum {
  Admin = 'admin',
  Agent = 'agent',
  Manager = 'manager',
  Merchant = 'merchant',
}

export type UserRoleBadgeTone = 'amber' | 'rose';

export type RoleLabelKey =
  'roles.admin' | 'roles.manager' | 'roles.agent' | 'roles.merchant';

export const INTERNAL_ROLES = [
  UserRoleEnum.Admin,
  UserRoleEnum.Manager,
] as const;

export const EXTERNAL_ROLES = [
  UserRoleEnum.Agent,
  UserRoleEnum.Merchant,
] as const;

export const DASHBOARD_PATH_BY_ROLE: Record<UserRoleEnum, string> = {
  [UserRoleEnum.Admin]: '/admin',
  [UserRoleEnum.Agent]: '/agent',
  [UserRoleEnum.Manager]: '/admin',
  [UserRoleEnum.Merchant]: '/merchant',
};

export const ROLE_BY_BACKEND_ROLE: Record<UserRole, UserRoleEnum> = {
  admin: UserRoleEnum.Manager,
  agent: UserRoleEnum.Agent,
  merchant: UserRoleEnum.Merchant,
  super_admin: UserRoleEnum.Admin,
};

export const BACKEND_ROLE_BY_UI: Record<UserRoleEnum, UserRole> = {
  [UserRoleEnum.Admin]: 'super_admin',
  [UserRoleEnum.Agent]: 'agent',
  [UserRoleEnum.Manager]: 'admin',
  [UserRoleEnum.Merchant]: 'merchant',
};

export const ROLE_LABEL_KEY: Record<UserRole, RoleLabelKey> = {
  admin: 'roles.manager',
  agent: 'roles.agent',
  merchant: 'roles.merchant',
  super_admin: 'roles.admin',
};

export const ROLE_BADGE_VARIANT: Record<
  UserRole,
  'admin' | 'manager' | 'agent' | 'merchant'
> = {
  admin: 'manager',
  agent: 'agent',
  merchant: 'merchant',
  super_admin: 'admin',
};

export interface AssignableRoleOption {
  internal: boolean;
  labelKey: RoleLabelKey;
  value: UserRole;
}

export const ASSIGNABLE_ROLES: readonly AssignableRoleOption[] = [
  {
    internal: true,
    labelKey: 'roles.admin',
    value: 'super_admin',
  },
  {
    internal: true,
    labelKey: 'roles.manager',
    value: 'admin',
  },
  {
    internal: false,
    labelKey: 'roles.merchant',
    value: 'merchant',
  },
  {
    internal: false,
    labelKey: 'roles.agent',
    value: 'agent',
  },
] as const;

export const ROLE_OPTIONS_INTERNAL: readonly UserRole[] = [
  'super_admin',
  'admin',
] as const;

export const ROLE_OPTIONS_EXTERNAL: readonly UserRole[] = [
  'agent',
  'merchant',
] as const;
